import { useQuery } from '@tanstack/react-query';
import { ENVIRONMENTS } from '@elementary/common-ui/constants/queryKeys';
import * as api from '../services/settingsApi';

/**
 * Side-effect-free observer on the shared [ENVIRONMENTS] React Query cache
 * entry. Use this when you just need the env list (e.g. a dropdown) and do
 * NOT want the URL-navigation / Recoil-selected-env side effects of
 * `useEnvironments`. `useEnvironmentsPolling()` in AppShell keeps the cache
 * warm, so observers added by this hook usually read from cache.
 */
const useEnvironmentsData = () =>
  useQuery([ENVIRONMENTS], () => api.fetchEnvironments());

export default useEnvironmentsData;
